/*
 * @Description: 在空间Z上的边
 * @Author: Xiaohua Zhu
 * @Date: 2021-12-02 19:15:44
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-02-14 14:22:49
 */
import BaseLength from './baseLength';
import { TOPFRAME_GROUND, GAP_BETWEEN_WALL_AND_CABINET, } from '../utils/kitchenConfig';
import Wall from '../room/wall';
class LengthP2Z extends BaseLength {
    createWall(width, toLengthZDistance) {
        const wallNode = new Wall(this.scene);
        const sideLength = width;
        const fromPoint = { x: 2 * GAP_BETWEEN_WALL_AND_CABINET, y: 0, z: 0 };
        const toPoint = { x: -sideLength - 2 * GAP_BETWEEN_WALL_AND_CABINET, y: 0, z: 0 };
        const wallSegmentNode = {
            toPoint,
            fromPoint,
            wallHeight: TOPFRAME_GROUND(this.templateJson),
            name: 'lengthP2Z',
        };
        wallNode.createWall(wallSegmentNode, { x: 0, y: Math.PI / 2, z: 0 }, { x: -toLengthZDistance, y: 0, z: 0 });
        this.wallNode = wallNode;
    }
}
export default LengthP2Z;
